import cn from 'classnames';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import * as st from './styles.module.scss';

type Props = {
  id: number;
  isIndividualCoachCard?: boolean;
};

export const Avatar: React.FC<Props> = ({ id, isIndividualCoachCard = false }) => {
  const { data: coach } = useCoachQuery({ id: String(id) });

  return <img alt="" className={cn(st.avatar, !coach?.photo && st.hidden)} src={coach?.photo} />;
};
